import { Check } from "lucide-react";

// Glowing blue "Partner" verified tick shown on featured OCE DOGS streamers.
export const PartnerBadge = ({ size = 20, showLabel = false, label = "Partner", className = "" }) => (
  <span
    className={`inline-flex items-center gap-1.5 align-middle ${className}`}
    title="OCE DOGS Partner"
    data-testid="partner-badge"
  >
    <span
      className="partner-box inline-flex items-center justify-center rounded-[5px] shrink-0"
      style={{ width: size, height: size }}
    >
      <Check strokeWidth={4} style={{ width: size * 0.64, height: size * 0.64 }} className="text-white" />
    </span>
    {showLabel && (
      <span className="partner-label font-stencil font-bold uppercase text-[11px] tracking-wider">{label}</span>
    )}
  </span>
);

export default PartnerBadge;
